import { FC, useCallback } from 'react'
import type { CrmIntegrationAttachment } from '../../types/crm-integration-chat.types'
import {
  attachmentVideoDisplayName,
  attachmentVideoMetaLabel,
  attachmentVideoPoster,
  attachmentVideoSrc,
  attachmentVkVideoExternalUrl,
} from '../../lib/crmIntegrationAttachment'
import classes from '../../styles/crmIntegrationChat.module.css'

type CrmIntegrationIncomingVideoProps = {
  att: CrmIntegrationAttachment
  onPlaybackError?: () => void
}

const CrmIntegrationIncomingVideo: FC<CrmIntegrationIncomingVideoProps> = ({
  att,
  onPlaybackError,
}) => {
  const videoSrc = attachmentVideoSrc(att)
  const poster = attachmentVideoPoster(att)
  const vkUrl = attachmentVkVideoExternalUrl(att)
  const title = attachmentVideoDisplayName(att)
  const metaLabel = attachmentVideoMetaLabel(att)

  const handlePlaybackError = useCallback(() => {
    onPlaybackError?.()
  }, [onPlaybackError])

  if (att.kind !== 'video') {
    return null
  }

  if (videoSrc) {
    return (
      <div className={classes.bubbleVideoCard}>
        <video
          className={classes.bubbleVideoPlayer}
          src={videoSrc}
          poster={poster ?? undefined}
          controls
          preload="metadata"
          playsInline
          onError={handlePlaybackError}
        />
        {title || metaLabel ? (
          <p className={classes.bubbleVideoText}>
            {title ? (
              <span className={classes.bubbleVideoTitle}>{title}</span>
            ) : null}
            {metaLabel ? (
              <span className={classes.bubbleAttachmentLink}>{metaLabel}</span>
            ) : null}
          </p>
        ) : null}
      </div>
    )
  }

  if (poster) {
    return (
      <div className={classes.bubbleVideoCard}>
        {vkUrl ? (
          <a
            className={classes.bubbleVideoCoverLink}
            href={vkUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Открыть видео «${title}» во ВКонтакте`}
          >
            <img
              className={classes.bubbleVideoCover}
              src={poster}
              alt=""
              loading="lazy"
              decoding="async"
            />
          </a>
        ) : (
          <img
            className={classes.bubbleVideoCover}
            src={poster}
            alt=""
            loading="lazy"
            decoding="async"
          />
        )}
        <p className={classes.bubbleVideoText}>
          {title ? (
            <span className={classes.bubbleVideoTitle}>{title}</span>
          ) : null}
          {metaLabel ? (
            <span className={classes.bubbleAttachmentLink}>{metaLabel}</span>
          ) : null}
          {vkUrl ? (
            <a
              className={classes.bubbleAttachmentLink}
              href={vkUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Открыть в VK
            </a>
          ) : null}
        </p>
      </div>
    )
  }

  if (vkUrl) {
    return (
      <a
        className={classes.bubbleAttachmentLink}
        href={vkUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        Открыть видео в VK
      </a>
    )
  }

  return (
    <span className={classes.bubbleAttachmentLink}>Видео недоступно</span>
  )
}

export default CrmIntegrationIncomingVideo
